import React from 'react'

import s from 'stores/ooka_usa_store/components/LoadingIndicator/Indicator.module.scss'

export const LoadingIndicator: React.FC<{
    isHubSpotLoader?: boolean
}> = ({ isHubSpotLoader = false }) => {
    if (isHubSpotLoader) {
        return (
            <div id="hubspot-container" className={s['hubspot-container']}>
                <div className={s['loading-container']}>
                    <span className={s['loading-message']} />
                </div>
            </div>
        )
    }

    return (
        <div className={s['loading-container']}>
            <span className={s['loading-message']} />
        </div>
    )
}
